import { MONTH_NAME_PATTERN } from '../../configs/date-config';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AvailableCoupon } from '../../models/available-coupon.model';

@Component({
standalone: false,
  selector: 'app-coupon-select-row',
  styleUrls: ['./coupon-select-row.component.scss'],
  templateUrl: './coupon-select-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CouponSelectRowComponent {
  @Input() coupon: AvailableCoupon;
  @Input() selected: boolean;
  @Input() disabled: boolean;
  @Output() couponClicked = new EventEmitter<void>();

  public loading: boolean;

  public readonly datePattern: string = MONTH_NAME_PATTERN;

  constructor() {
  }

  onCouponClicked() {
    if (!this.disabled && !this.selected) {
      this.loading = true;
      this.couponClicked.emit();
    }
  }
}
